// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrentPlant_wrapper__ZLeYk","container":"CurrentPlant_container__tYuUu"};